import $ from 'jquery'
import lottie from 'lottie'
import { breakpoints } from './_site'
import lottieMenuData from '../lottie-menu.json'

let lottieInstance

export const timeout = {}
export const toggleSearch = ($menuItem) => {
  var $item = $menuItem.parent(),
    menuItemClass = 'menu__item',
    menuItemClassHover = menuItemClass + '--hover',
    $search = $('#search-form')

  // reset others
  $('#menu')
    .find('.' + menuItemClass)
    .not($item)
    .removeClass(menuItemClassHover)

  $item.addClass(menuItemClassHover)

  if ($item.is('.menu__item--mega')) {
    $('body').addClass('megamenu-active')
  } else {
    $('body').removeClass('megamenu-active')
  }

  $search.show()
  $search.siblings().hide()
}
export const toggle = () => {
  // $('body').toggleClass('menu-active');
  // $('body').removeClass('cart-active sidebar-active');

  var $body = $('body')

  // toggle header
  $body.toggleClass('header-active')
  $('.blobmenu').toggleClass('blobmenu--active')

  // reset sublevels
  $body.removeClass('cart-active menu-active megamenu-active megamenu-submenu-active')

  clearTimeout(timeout.toggleMenu)
  timeout.toggleMenu = setTimeout(function () {
    if ($body.hasClass('header-active')) {
      $body.addClass('menu-active')
      $('.blobmenu').addClass('blobmenu--active')
    }
  }, 300)
}
export const megamenuMenuToggle = () => {
  $('body').toggleClass('megamenu-active')
}
export const megamenuSubmenuToggle = () => {
  $('body').toggleClass('megamenu-submenu-active')
}
export const responsiveHideMenu = () => {
  // $('body').removeClass('header-active menu-active');
  $('body').removeClass('header-active menu-active megamenu-active megamenu-submenu-active')
}
// export const responsiveHideMenu = (classes) => {
//     $('body').removeClass('header-active menu-active megamenu-active megamenu-submenu-active');
// };
export const responsiveMenu = (flag) => {
  var $menu = $('#menu'),
    submenuClass = 'menu__submenu',
    // menuItemClass = 'menu__item',
    // menuItemClassActive = menuItemClass + '--active',
    menuNavClass = 'menu-nav',
    menuNavClassDefault = menuNavClass + '--default',
    menuNavClassResponsive = menuNavClass + '--responsive'

  if (flag) {
    $menu.removeClass(menuNavClassDefault).addClass(menuNavClassResponsive)
  } else {
    $menu.removeClass(menuNavClassResponsive).addClass(menuNavClassDefault)
    // $menu.find('.' + menuItemClass).removeClass(menuItemClassActive);
    $menu.find('.' + submenuClass).css({
      display: '',
    })
  }
}
export const responsiveMegamenuMenu = (flag) => {
  if (flag) {
    $('.megamenu-nav').off('mouseenter.menu', '[data-toggle="tab"], [data-hover="tab"]')
    $('.megamenu-nav').on('click.menu', '[data-toggle="tab"], [data-hover="tab"]', function (event) {
      event.preventDefault()
      var $el = $(this),
        $target = $($el.data('target'))

      $target.show()
      $target.siblings().hide()
    })
  } else {
    $('.megamenu-nav').on('mouseenter.menu', '[data-toggle="tab"], [data-hover="tab"]', function () {
      $(this).tab('show')
    })
    $('.megamenu-nav').off('click.menu')
  }
}
export const resize = () => {
  var $window = $(window)

  // md
  if ($window.width() < breakpoints.md) {
    responsiveMenu(true)
    responsiveMegamenuMenu(true)
  } else {
    responsiveMenu(false)
    responsiveMegamenuMenu(false)

    responsiveHideMenu()
  }
}
// export const defaultFocus = ($menuItem) => {
//     var $item = $menuItem.parent(),
//         menuItemClass = 'menu__item',
//         menuItemClassHover = menuItemClass + '--hover';
//
//     // reset others
//     $('#menu').find('.' + menuItemClass).not($item).removeClass(menuItemClassHover);
//
//     $item.addClass(menuItemClassHover);
//
//     if ($item.is('.menu__item--mega')) {
//         $('body').addClass('megamenu-active');
//     } else {
//         $('body').removeClass('megamenu-active');
//     }
// };
// export const defaultBlur = () => {
//     var menuItemClass = 'menu__item',
//         menuItemClassHover = menuItemClass + '--hover',
//         $item = $('.' + menuItemClassHover);
//
//     // remove active item
//     $('body').removeClass('megamenu-active');
//     // remove active item
//     $item.removeClass(menuItemClassHover);
// };
export const defaultFocus = ($menuItem) => {
  var $item = $menuItem.parent(),
    menuItemClass = 'menu__item',
    menuItemClassHover = menuItemClass + '--hover',
    $search = $('#search-form')

  // reset others
  $('#menu')
    .find('.' + menuItemClass)
    .not($item)
    .removeClass(menuItemClassHover)

  $item.addClass(menuItemClassHover)

  if ($item.is('.menu__item--mega')) {
    $('body').addClass('megamenu-active')
  } else {
    $('body').removeClass('megamenu-active')
  }

  $search.hide()
  $search.siblings().show()
}
export const defaultBlur = (event) => {
  var $target = $(event.target),
    menuItemClass = 'menu__item',
    menuItemClassHover = menuItemClass + '--hover',
    $item = $('.' + menuItemClassHover)

  if ($target.closest('.menu').length) {
    return
  }

  // remove active item
  $('body').removeClass('megamenu-active')
  // remove active item
  $item.removeClass(menuItemClassHover)
}
export const binds = () => {
  // ---------------- toggle menu
  $('[data-menu-toggle]').on('click.menu', function (event) {
    event.preventDefault()
    toggle()
  })

  // ---------------- toggle search
  $('[data-search-toggle]').on('click.menu', function (event) {
    event.preventDefault()
    toggleSearch($(this))
  })

  // ---------------- menu (default)
  // $('#header').on('focusin.menu mouseenter.menu', '.menu-nav--default .menu__link', function() {
  $('#header').on('click.menu', '.menu-nav--default .menu__item--mega .menu__link', function (event) {
    event.preventDefault()
    defaultFocus($(this))
  })
  // $('#header').on('mouseleave.menu', '.menu-nav--default .menu', function() {
  $(document).on('click.menu', function (event) {
    defaultBlur(event)
  })

  // ---------------- megamenu menu
  $('body').on('click.menu', '.menu-nav--responsive .menu__item--mega .menu__link', function (event) {
    event.preventDefault()
    megamenuMenuToggle()
  })

  // ---------------- megamenu submenu
  $('body').on('click.menu', '.menu-nav--responsive .megamenu__item', function () {
    megamenuSubmenuToggle()
  })

  // ---------------- megamenu menu toggle
  $('[data-megamenu-toggle]').on('click.menu', function (event) {
    event.preventDefault()
    megamenuMenuToggle()
  })

  // ---------------- megamenu submenu toggle
  $('[data-megamenu-submenu-toggle]').on('click.menu', function (event) {
    event.preventDefault()
    megamenuSubmenuToggle()
  })

  // ---------------- window events
  $(window).on('resize.menu', function () {
    clearTimeout(timeout.menuResize)
    timeout.menuResize = setTimeout(function () {
      resize()
    }, 100)
  })
  $(window).triggerHandler('resize.menu')

  var morphing = anime({
    targets: '.morph',
    d: [
      {
        value:
          'M5.7,140.249c0,587.266,526.429,183.557,619.445,364.322,0,0,207.694,354.474,747.893-23.177,0,0,527.528,177.213,552.663-334.445V7.4H5.7Z',
      },
      {
        value:
          'M5.7,43.113c0,587.267,510.648-55.327,603.663,125.438,0,0,413.447,462.689,953.646,85.038,0,0,337.557,332.362,362.691-179.3V7.4H5.7Z',
      },
      {
        value:
          'M5.7,140.249c0,587.266,601.045,148.661,694.061,329.426,0,0,443.679,686.589,1076.314,238.222,0,0,124.49-49.29,149.625-560.949V7.4H5.7Z',
      },
      {
        value:
          'M5.7,273.1c0,1174.532,144.815,725.3,539.051,750.072,0,0,1096.38,186.064,1252.443-178.48,0,0,128.506-173.93,128.506-558.193V7.4H5.7Z',
      },
    ],
    easing: 'easeInOutQuad',
    duration: 900,
    loop: false,
    autoplay: false,
    delay: 200,
  })

  $('.toggle-menu').click(function () {
    $(this).toggleClass('toggle-menu--active')

    if ($(this).hasClass('toggle-menu--active')) {
      // morphing.restart();
      // $('.morphs').addClass('pointer');

      lottieInstance.setDirection(1)
      lottieInstance.playSegments([0, 45], true)
    } else {
      // morphing.reverse();
      // morphing.play();
      // $('.morphs').removeClass('pointer');

      lottieInstance.playSegments([50, 80], true)
    }
  })

  // Load lottie
  lottieInstance = lottie.loadAnimation({
    container: document.getElementById('menu-bg'), // the dom element that will contain the animation
    renderer: 'svg',
    loop: false,
    autoplay: false,
    animationData: lottieMenuData,
    name: 'menu',
    rendererSettings: {
      preserveAspectRatio: 'xMinYMin slice', // Supports the same options as the svg element's preserveAspectRatio property
    },
  })
}
